import { render, staticRenderFns } from "./BookingPriceTip.vue?vue&type=template&id=5a5a999b&scoped=true"
import script from "./BookingPriceTip.vue?vue&type=script&lang=js"
export * from "./BookingPriceTip.vue?vue&type=script&lang=js"
import style0 from "./BookingPriceTip.vue?vue&type=style&index=0&id=5a5a999b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5a999b",
  null
  
)

export default component.exports